// import "yakuhanjp/dist/css/yakuhanjp.css";
import {initFadeSwiper, initSwipeSwiper, initThumnailSwiper} from './js/initSwiper.js';
import {modalFX} from './js/modalFX.js'
import {submenuToggle, Accordions} from './js/Accordion.js';
import {SmoothScroll} from './js/SmoothScroll.js';
import {Region} from './js/Region.js';
// import {planDetail} from './js/planDetail.js';
// import {Validation} from './js/Validation.js';


if (import.meta.env.DEV) {
  // ViteでCSSを読み込むのは開発環境のみ
  // 本番環境はgulpでCSSをビルドする
  // import('./scss/bulma-custom.min.scss');
  // import('./scss/swiper-bundle.min.scss');
  // import('./scss/swiper.scss');
  // import('./scss/modal-fx.min.scss');
  // import('./scss/style-desktop-menu.scss');
  // import('./scss/style-mobile-menu.scss');
  // import('./scss/style.scss');
}



async function initModal () {
  const modal = modalFX();
  modal.init();
  console.log('mobileFx.js loaded!');
}

// await globalNav.init();// メニューの書き出し
await initModal();
await initFadeSwiper();
await initSwipeSwiper();
await initThumnailSwiper();
await Region.init();

SmoothScroll(-90);
//planDetail.init();
// Accordions();

/**---------------------------------------------
 * method:バリデーションメソッド（String | Email | Phone | Hiragana | Date | Password）
 * name:フォームのname属性
 * title:表示名
 * required:必須項目か否か（true | false）
**-----------------------------------------------*/
// const schemas = [
//   {"method":"String","name":`INQ_name`, "title":"氏名", "required":true},
//   {"method":"String","name":`INQ_rubi`, "title":"ふりがな", "required":true},
//   {"method":"Email","name":`INQ_email`, "title":"メールアドレス", "required":true},
//   {"method":"Phone","name":`INQ_phone`, "title":"電話番号", "required":false},
// ];

// Validation.init(schemas,{
//   targetFormId:`form`, // バリデーションを実行するフォームのID
//   resultBoxId:`result`,// エラーメッセージを表示する要素のID
//   trigger : 'both', // 'blur' | 'submit' | 'both' // バリデーションの実行タイミング
//   backgroundClass:`has-background-warning-light`, // エラー発生時のinput要素の背景色
//   errorClass:`validate-error`,// エラー発生時のエラーメッセージのクラス名
//   submitButtonClass:`btnSubmit`, // 送信ボタンのクラス名
//   preventSubmit:true, // エラー発生時に送信ボタンを無効化するかどうか
//   outputFormated:true, // フォーマットを適用するかどうか
// });

// テーマを切り替え
//document.documentElement.setAttribute
const main = document.querySelector(`div#container div#clearfix main`);
if(main){
  document.querySelector(`div#container div#clearfix main`).classList.add(`content`);
}
